<div class="mmp-dialog mmp-survey-dialog">
  <div class="modal-header mmp-dialog-header">
    <h4 class="modal-title mmp-dialog-title" id="mmp-survey-modal-title">Feedback survey</h4>
    <button type="button" class="close" aria-label="Close" (click)="closeSurvey()" title="Skip survey">
      <i class="fas fa-times" aria-hidden="true"></i>
    </button>
  </div>

  <div class="modal-body mmp-dialog-body mmp-survey-dialog-body">
    <survey [model]="surveyModel"></survey>
  </div>
</div>
